export const wait = ms => new Promise((r, j) => setTimeout(r, ms));


// WEBPACK FOOTER //
// ./src/js/utils/promise.js